import { jwtDecode } from 'jwt-decode';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { getToken } from './auth';

interface PrivateRouteProps {
    children: React.ReactNode;
    role?: string;
}

interface JwtPayload {
    exp: number;
    id: string;
    userName: string;
    role: string;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, role }) => {
    const token = getToken();

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    try {
        const decodedToken: JwtPayload = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
            return <Navigate to="/login" replace />;
        }

        if (role && decodedToken.role !== role) {
            return <Navigate to="/resume/active" replace />;
        }
    } catch (error) {
        console.error('JWT decoding error:', error);
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};
